import { Stack } from 'components';
import { ReactNode } from 'react';

import style from './history.module.scss';
import { useFooterContext } from './FooterContext';

export const Description = ({ children }: { children: ReactNode }) => {
  return <p className={style.submittedOn}>{children}</p>;
};

export const PersonInfo = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      className={style.author}
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="4px"
    >
      {children}
    </Stack>
  );
};

export const Item = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      py="12px"
    >
      {children}
    </Stack>
  );
};

export const History = ({ children }: { children: ReactNode }) => {
  const { historyOpen } = useFooterContext();

  return (
    <Stack
      data-open={historyOpen}
      sx={{
        '* + *': {
          borderTop: '1px solid #F1F5F9'
        }
      }}
      className={style.history}
      display="flex"
      flexDirection="column"
      overflow="auto"
    >
      {children}
    </Stack>
  );
};
